import { Draft } from 'immer';
import { Cell, CellPosition, ReferenceType, Sheet } from '../../types';
import { SheetManagementSet } from '../../types/sheet/draft';
import { createCell, getCell, isCellFormula } from '../cells/cellCRUD';
import { convertPositionToAddress } from '../address/singleAddress';
import { addDependencies, clearDependencies } from './dependencies';
import { CellDependency, startComputingIndeps } from './compute';

export interface ProcessReferencesConfigs {
  stopFormulaCalculation: boolean;
}
export async function processReferences(
  set: SheetManagementSet,
  sheet: Draft<Sheet>,
  // sheetId: string,
  cellPosition: CellPosition,
  cell: Cell,
  configs?: Partial<ProcessReferencesConfigs>
) {
  const sheetId = sheet.id;
  let calculateSelf = false;
  const cellAddress = convertPositionToAddress(cellPosition);

  const cellsReferences = sheet.cellsReferences;

  const cellRefs = getCell(cellsReferences, cellPosition);

  if (cellRefs?.d) {
    await clearDependencies(
      set,
      sheetId,
      cellsReferences,
      cellRefs,
      cellPosition,
      cellAddress
    );
  }

  if (isCellFormula(cell)) {
    calculateSelf = true;
    const formula = cell.v!.toString();
    const cellRefs = createCell(cellsReferences, cellPosition);
    await addDependencies(set, sheetId, cellRefs, cellAddress, formula);
  }

  const cellDependency: CellDependency = {
    type: ReferenceType.CellFormula,
    cellPosition,
    cellAddress,
    calculateSelf,
  };

  if (!configs?.stopFormulaCalculation)
    await startComputingIndeps(set, sheetId, cellDependency);
}
